"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DataGridDesktopBody_1 = __importDefault(require("./DataGridDesktopBody"));
var DataGridMobileBody_1 = __importDefault(require("./DataGridMobileBody"));
var hoc_1 = require("../hoc");
var DataGridBody = function (props) {
    var isMobileBody = props.isMobileBody, otherProps = __rest(props, ["isMobileBody"]);
    return isMobileBody ? (react_1.default.createElement(DataGridMobileBody_1.default, __assign({}, otherProps))) : (react_1.default.createElement(DataGridDesktopBody_1.default, __assign({}, otherProps)));
};
exports.default = (0, hoc_1.infiniteLoaderHOC)(DataGridBody);
